var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#458BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8302_39609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2427 15.5746L12 19.8173L7.75734 15.5746C6.91823 14.7355 6.34679 13.6664 6.11529 12.5025C5.88378 11.3387 6.0026 10.1323 6.45673 9.03591C6.91086 7.93956 7.6799 7.00249 8.66659 6.34321C9.65328 5.68392 10.8133 5.33203 12 5.33203C13.1867 5.33203 14.3467 5.68392 15.3334 6.34321C16.3201 7.00249 17.0891 7.93956 17.5433 9.03591C17.9974 10.1323 18.1162 11.3387 17.8847 12.5025C17.6532 13.6664 17.0818 14.7355 16.2427 15.5746ZM12 12.6653C12.3536 12.6653 12.6928 12.5248 12.9428 12.2748C13.1929 12.0247 13.3333 11.6856 13.3333 11.332C13.3333 10.9784 13.1929 10.6392 12.9428 10.3892C12.6928 10.1391 12.3536 9.99865 12 9.99865C11.6464 9.99865 11.3072 10.1391 11.0572 10.3892C10.8071 10.6392 10.6667 10.9784 10.6667 11.332C10.6667 11.6856 10.8071 12.0247 11.0572 12.2748C11.3072 12.5248 11.6464 12.6653 12 12.6653Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8302_39609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.cbee9d0a8adaddc34a7c3b48b3ce6cf3.svg";
export { ForwardRef as ReactComponent };